import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SettingsPage } from '../settings/settings';
import { SearchProvider } from '../../providers/search/search';
import { Observable } from 'rxjs';
import { HexonProvider } from '../../providers/hexon/hexon';
import { DomProvider } from '../../providers/dom/dom';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {
  public placeholder = '';
  public companyName$: Observable<string>;

  private readonly fields = {
    kenteken: {
      fieldname: 'identification.license_plate',
      placeholder: 'AB-12-CD'
    },
    merk: {
      fieldname: 'general.make.name',
      placeholder: 'Alfa Romeo'
    },
    model: {
      fieldname: 'general.model.name',
      placeholder: 'Giulietta'
    },
    type: {
      fieldname: 'general.type.name',
      placeholder: 'Comfortline'
    }
  };

  constructor(
    public navCtrl: NavController,
    public search: SearchProvider,
    private hexon: HexonProvider,
    private dom: DomProvider
  ) {
    this.companyName$ = this.hexon
      .getSetting$()
      .map(setting => setting.data[0].name_own_company)
      .shareReplay(1);
  }

  public ngOnInit() {
    this.placeholder = this.fields.kenteken.placeholder;
    this.search.setField('identification.license_plate');
  }

  public goToSettings() {
    this.navCtrl.push(SettingsPage, { companyName$: this.companyName$ });
  }

  public goToHelp() {
    this.dom.go('https://autoflex10.atlassian.net/wiki/x/KQCbI');
  }

  public updateQuery(query: string) {
    this.search.setQuery(query);
  }

  public enterQuery(evt: KeyboardEvent, query: string) {
    if (evt.key === 'Enter') {
      this.search.setQuery(query);
    }
  }

  public updateField(field: string) {
    this.placeholder = this.fields[field].placeholder;
    this.search.setQuery('');
    this.search.setField(this.fields[field].fieldname);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts